import { MeridianClient, type AssetRequest as ApiAssetRequest } from '../../../../packages/sdk/src/index';
export type AssetRequest = {
  id: string; name: string; sourceChain: string; sourceMint: string | null;
  votes: number; reviewedAt: number | null; reviewDueAt: number | null;
  review: string; voted: boolean; status: ApiAssetRequest['status'];
};
export type RequestDraft = { name: string; sourceChain: string; sourceMint: string; evidence: string };
export type RequestListing = { available: false; reason: string } | { available: true; requests: AssetRequest[] };
export interface AssetRequestAdapter {
  list(): Promise<RequestListing>;
  submit(draft: RequestDraft): Promise<void>;
  vote(id: string, voted?: boolean): Promise<void>;
}
type RequestClient = Pick<MeridianClient, 'assetRequests' | 'submitAssetRequest' | 'voteAssetRequest'>;
export function createAssetRequestAdapter(client: RequestClient): AssetRequestAdapter {
  return {
    async list() {
      const requests = await client.assetRequests(100, 0);
      return {available: true, requests: requests.map(request => ({
        id: request.id, name: request.name, sourceChain: request.sourceChain ?? 'Source chain pending research',
        sourceMint: request.sourceMint, votes: request.voteCount, reviewedAt: request.reviewedAt,
        reviewDueAt: request.reviewDueAt, review: request.reviewNote ?? 'No review recorded. Trading approval has not been granted.',
        voted: request.voted, status: request.status,
      }))};
    },
    async submit(draft) {
      if (draft.sourceChain.toLowerCase() !== 'solana') throw new Error('Only Solana candidates are supported.');
      await client.submitAssetRequest({name: draft.name.trim(), sourceChain: 'solana',
        ...(draft.sourceMint.trim() ? {sourceMint: draft.sourceMint.trim()} : {}), description: draft.evidence.trim()});
    },
    async vote(id, voted = true) { await client.voteAssetRequest(id, voted); },
  };
}
